///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.items = abcsetup.promos.items || {};
abcsetup.promos.items.manage_items = abcsetup.promos.items.manage_items || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.items.manage_items = {
    init: function() {

        abcsetup.setTitle('Manage Promotion Items');
        abcsetup.item = JSON.parse($('form.manage-items #item_object').val());

        // Serialize each form into a data-serialize attribute to compare against later
        $('form').each(function () {
            $(this).attr('data-serialize', $(this).serialize());
        });

        // this code copied from _vendor_edit.js:  lock the form for promos with attributes if the promo has been submitted
        var editable_status = ["vendor_in_process","cm_rejected",'reject_approved']
        var editable = !abcsetup.item.promo_attr[0] || !abcsetup.item.promo_attr[0].review_status || (abcsetup.item.promo_attr[0] && editable_status.includes(abcsetup.item.promo_attr[0].review_status));
        abcsetup.promos.form_manager.form = $('form.manage-items');
        if (editable) {
            abcsetup.promos.form_manager.setFormItems();
            if(abcsetup.item.promo_type?.id == 'hp') {
                // Set the $ off values
                for (var i in abcsetup.item.promo_items) {
                    $("input[name='discount_"+abcsetup.item.promo_items[i].item+"']").val(abcsetup.item.promo_items[i].discount_dollar);
                }
            }
            // Set all promo_attr input fields from sessionStorage: the user can go between the
            // promo manage and item views
            $(":input.promo_attr").each(function() {
                var _this = $(this);
                if (sessionStorage.getItem(_this.attr('name'))) {
                    _this.val(sessionStorage.getItem(_this.attr('name')));
                }
            });
        } else {
            abcsetup.promos.form_manager.setFormItems(true);
        }

        // For Central banner ad GNP type, we need to store the goal / website links in a session variable
        // The user can go between the manage view and the item view, so we need to store the goal / website
        if ($("#gnp_campaign_goal").is(":visible") && sessionStorage.getItem("goal") && $("#gnp_campaign_goal").val() == '')
        {
            $("#gnp_campaign_goal").val(sessionStorage.getItem("goal"));
        }

        if ($("#supplier_website_link").is(":visible") && sessionStorage.getItem("website") && $("#supplier_website_link").val() == '')
        {
            $("#supplier_website_link").val(sessionStorage.getItem("website"));
        }

        // Show the add item modal
        $('#add-btn').on("click", function() {
            abcsetup.promos.items.manage_items.addItem();
        });

        // Item modal field(s) changed
        $('#item-modal input, #item-modal select').on('change keyup', function() {
            clearTimeout(abcsetup.promos.items.manage_items.itemTimeout);

            abcsetup.promos.items.manage_items.itemTimeout = setTimeout(function() {
                abcsetup.promos.items.manage_items.findItems();
            }, 1500);
        });

        //
        $(document).on('click', '.promo_item_promos', function (e) {
            abcsetup.promos.items.manage_items.showPromotions($(this).data('item-id'));
        });

        $(document).on('click', '.btn.btn-link', function (e) {
            abcsetup.promos.items.manage_items.appendItem($(this).data('id'));
        });

        // Remove item button clicked
        $(document).on('click', '.btn.btn-remove-item', function (e) {
            var promo_id = $('input[name="promo_id"]').val();
            var item = $(this).data('item_id');
            let category = $(this).data('category_id');
            var _this = $(this);

            if (abcsetup.item.type == 'fsa_hsa') {
                let open_slots = $('#open_slots_' + category + '').val();
                let new_open_slots = parseInt(open_slots) + 1;
                $('#open_slots_' + category + '').val(new_open_slots);
                $('#open_slot_html_' + category + '').html(new_open_slots);
            }

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to remove this item?', function (resp) {
                if (resp) {
                    abcsetup.blockUI(true);
                    axios.delete('/api/promoitem/delete?promo_id='+promo_id+'&item='+item)
                        .then(response => {
                            abcsetup.unblockUI();
                            _this.closest('tr.first').fadeOut('slow', function() {
                                $(this).remove();

                                if ($('#new_items_table tr').length <= 2) {
                                    $('#new_items_table').hide();
                                }
                        })
                        .catch(error => {
                            abcsetup.unblockUI();
                            abcsetup.alerts.show('Could not remove Item', `An error occurred while trying to remove the item: ${error.response.data.error}. Please reach out to support for assistance.`);
                        });
                    });
                }
            });
        });
        $(document).on('click',"button[type='submit']",function(){
            console.log('submit');

            $('tr.first').each(function(){
                $(this).find('.btn.btn-open-view').find('i').removeClass('fa-caret-down').addClass('fa-caret-up');
                $(this).find('.btn.btn-open-view').removeClass('btn-open-view').addClass('btn-hide-view');
            });
            $('tr.second').each(function(){
                $(this).find('table').show()
            });

            if ($(this).val()=='submit' && $(this).data('agreement')==true){
                return true;
            }

            if ($(this).val()=='submit' && abcsetup.item.type == 'cc') {
                // Ensure the supplier is aware of the minimum 6 month stock notice
                var submit_button = $(this);
                abcsetup.alerts.confirm('INVENTORY ACKNOWLEDGEMENT:', 'Please understand that this is a six-month promotional blitz, which requires a longer inventory commitment than other promotions. Please ensure all items submitted for the Consumer SearchBoost have sufficient inventory. If the inventory status changes, please contact Cencora regarding the item status, potential outages, and get well dates.', function (resp) {
                    if (!resp) {
                        return;
                    }
                    submit_button.data('agreement',true).trigger('click');
                });
                return false;
            }

        });
        $(document).on('change',"input.ship_period_to",function(){
            var item_id = $(this).closest('tr.second').find('input.item_id').val();
            fieldValidate.runValidations($('#saved_items_'+item_id+'_est_ship_date'));
        });
        $(document).on('change',"input.ship_period_from",function(){
            var item_id = $(this).closest('tr.second').find('input.item_id').val();
            fieldValidate.runValidations($('#saved_items_'+item_id+'_est_ship_date'));
        });
        $(document).on('change',"input[name='select-all-items']",function(){
            if ($(this).is(':checked')) {
                // Select All
                $('input[name="submitted_items[]"]').each(function () {
                    if (!$(this).is(':checked')) {
                        $(this).trigger('click');
                    }
                });
            }
            else {
                // De-select All
                $('input[name="submitted_items[]"]').each(function () {
                    if ($(this).is(':checked')) {
                        $(this).trigger('click');
                    }
                });
            }
            abcsetup.promos.items.manage_items.toggleSubmitButton();
        });
        $(document).on('change',"input[name='select-all-blocks']",function(){
            if ($(this).is(':checked')) {
                // Select All
                $('input[name="submitted_page_blocks[]"]').each(function () {
                    if (!$(this).is(':checked')) {
                        $(this).trigger('click');
                    }
                });
            }
            else {
                // De-select All
                $('input[name="submitted_page_blocks[]"]').each(function () {
                    if ($(this).is(':checked')) {
                        $(this).trigger('click');
                    }
                });
            }
            abcsetup.promos.items.manage_items.toggleSubmitButton();
        });
        $(document).on('change',"input[name='submitted_items[]']",function(){
            if ($(this).is(':checked')) {
                $(this).closest('tr').addClass('selected');
            }
            else {
                $(this).closest('tr').removeClass('selected');
            }
            abcsetup.promos.items.manage_items.toggleSubmitButton();
        });
        $(document).on('change',"input[name='submitted_page_blocks[]']",function(){
            if ($(this).is(':checked')) {
                $(this).closest('div.page_block').addClass('selected');
            }
            else {
                $(this).closest('div.page_block').removeClass('selected');
            }
            abcsetup.promos.items.manage_items.toggleSubmitButton();
        });

        // Copy bill back % button clicked (Copy to all)
        $(document).on('click', "a.copy-to-all-billback", function () {
            abcsetup.promos.items.manage_items.copyBillbackData($(this));
        });

        // Copy $ discount button clicked (Copy to all)
        $(document).on('click', "a.copy-to-all-dollar", function () {
            abcsetup.promos.items.manage_items.copyDiscountData($(this));
        });

        //Save goal and website links in session strage
        $(document).on('change',"#gnp_campaign_goal",function(){
             if ($('#gnp_campaign_goal').val !== '') {
                sessionStorage.setItem("goal", $('#gnp_campaign_goal').val());
             }
         });

        $(document).on('change',"#supplier_website_link",function(){
             if ($('#supplier_website_link').val !== '') {
                sessionStorage.setItem("website", $('#supplier_website_link').val());
             }
         });

        if (editable) {
            // Temporarily save the current input promo_attr fields to sessionStorage so that
            // we can restore them if the user switches between the promo manage and item
            // views
            $(document).on('change',":input.promo_attr",function(){
                var _this = $(this);
                if (_this.val() !== '') {
                    sessionStorage.setItem(_this.attr('name'), _this.val());
                }
            });
        }

        $(document).on('keyup',"input.competitive_product_upcs",function(){
            if ($(this).val().length == 12) {
                // A complete 12 digit UPC has been entered
                // Are there any existing UPC fields that are empty?
                var duplicates = 0;
                var filled_duplicates = 0;
                $('input.competitive_product_upcs').each(function(){
                    duplicates++
                    if($(this).val() != "")
                        filled_duplicates++;
                });

                // If they're all filled add another
                // Max 20 UPCs
                if (duplicates == filled_duplicates && !$('#competitive_product_upcs_'+duplicates).length && filled_duplicates<20) {
                    var field = abcsetup.promos.form_manager.form.find(':input[id="competitive_product_upcs_0"]');
                    var field_row = field.closest('.form-group.row').clone();
                    field_row.removeAttr('requiredIf');
                    field_row.removeAttr('required').removeClass('required');
                    field_row.find('label').attr('for','competitive_product_upcs_'+duplicates).html('--- '+(duplicates+1)+' ---');
                    field_row.find('input').attr('id','competitive_product_upcs_'+duplicates).val('').removeAttr('required').removeClass('invalid');
                    field_row.find('.errorMsg').remove();
                    console.log('last_dup->',$('#competitive_product_upcs_'+duplicates));
                    $('#competitive_product_upcs_'+(duplicates-1)).closest('.form-group.row').after(field_row);
                }
            }
        });

        // bind beforeunload event to warn user of unsaved changes in any form only if the unload event is not caused by the form submission
        $(window).on('beforeunload', function (e) {
            $('form').each(function () {
                if ($(this).serialize() !== $(this).attr('data-serialize')) {
                    return 'You have unsaved changes.';
                }
            });
        });

        // Disable mousewheel incrementing on number input fields for
        // Chromium based browsers (Edge, Chrome)
        $('form').on('focus', 'input[type=number]', function (e) {
            $(this).on('wheel.disableScroll', function (e) {
            e.preventDefault()
            })
        })

        $('form').on('blur', 'input[type=number]', function (e) {
            $(this).off('wheel.disableScroll')
        })

        // Bind the reject dropdown events
        abcsetup.promos.items.manage_items.bindSubmitDropdown();

        // Reject button clicked
        $('#submit_to_cm_btn').on('click', function () {
            abcsetup.promos.items.manage_items.submitToCm();
        });

    },

    /**
     * Bind the submit all to cm dropdown events
     */
    bindSubmitDropdown: function () {
        $('.dropdown-menu.reject input.checkbox').prop('checked', false);

        $(document).on('click', '.dropdown-menu.reject', function (event) {
            event.stopPropagation();
        });
    },

    /**
     * Submit to CM
    */
    submitToCm: function () {
        let error = false;
        const checkedItems = $('.dropdown-menu.reject input:checkbox:checked');

        //Click to Reject item
        if (checkedItems.length < 2) {
            abcsetup.alerts.flashMessage('Please select all the checkboxes before submitting to the Category Manager.', 'warning');

            error = true;
        }

        if (!error) {
            $('#submit_to_cm_btn').unbind('click').attr('type', 'submit').trigger('click');
        }
    },

    copyBillbackData: function (link) {
        // Copy data entered into billback % field to rest of the fields
        let billback_value = link.parent().find('input.billback_field').val();
        $('input.billback_field').val(billback_value);
    },

    copyDiscountData: function (link) {
        // Copy data entered into $ discount field to rest of the fields
        let discount_value = link.parent().find('input.discount_dollar_field').val();
        $('input.discount_dollar_field').each(function(){
            $(this).parent().find('div.alert-warning').remove();
            // Before just copying over the $ off amount, make sure its less than the zone 3 price
            var z3_price = $(this).parent().find("input[name='z3_price']").val();
            if (z3_price.length) {
                if (discount_value < z3_price)
                    $(this).val(discount_value);
                else
                    $(this).parent().append("<div class='alert alert-warning mt-1'>The copied $ off amount ($"+discount_value+") is greater than your product’s Zone 3 price. Please enter a $ off amount that is less than the product’s Zone 3 Retail Price which is <b>$ "+z3_price+"</b></div>");
            } else {
                // We dont know the z3 price so copy it over anyway
                $(this).val(discount_value);
            }
        });
    },

    toggleSubmitButton: function(){
        var item_selected = false;
        $('input[type=checkbox]').each(function () {
            if ($(this).attr('name') == 'select-all-blocks' || $(this).attr('name') == 'select-all-items') {
                return true;
            }
            if ($(this).is(':checked')) {
                item_selected = true;
                return;
            }
        });
        if (item_selected) {
            $("#submit_to_cm").html("Submit Selected to CM");
        }
        else {
            $("#submit_to_cm").html("Submit All to CM");
            if ($("input[name='select-all-items']").is(':checked')) {
                $("input[name='select-all-items']").trigger('click');
            }
            if ($("input[name='select-all-blocks']").is(':checked')) {
                $("input[name='select-all-blocks']").trigger('click');
            }
        }
    },

    /**
     * Show the add item modal
     */
    addItem: function() {
        $('#item-modal .modal-title').html('Search and Add Items to Event');
        $('#item-modal input, #item-modal select').val('');
        $('#item-modal').find('#results').data('searchString', '').html('');
        $('#item-modal').modal('show');
    },

    /**
     *
     */
    findItems: function() {
        var identifier = $('#item-modal').find('#identifier').val();
        var mfr_prod_code = $('#item-modal').find('#mfr_prod_code').val();
        var mat_descr = $('#item-modal').find('#mat_descr').val();
        var category = $('#item-modal').find('#category').val();

        // No search params are specified
        if (identifier == '' && mfr_prod_code == '' && mat_descr == '' && category == '') {
            $('#item-modal').find('#results').data('searchString', '').html('');
            return false;
        }

        // Come up with a unique search string to prevent duplicate search
        var searchString = identifier + mfr_prod_code + mat_descr + category;
        if ($('#item-modal').find('#results').data('searchString') == searchString) {
            return false;
        }

        // Remember the unique search string
        $('#item-modal').find('#results').data('searchString', searchString);

        // Block the UI with a spinner
        abcsetup.blockUI(true);
        abcsetup.promos.items.manage_items.items = [];

        const matches = /.promos\/([0-9]+)/.exec(window.location.pathname);
        const promo = Array.isArray(matches) && matches.length >= 2 ? matches[1] : '';

        let searchParams = 'identifier='     + identifier    +
                           (abcsetup.item.type=='fsa_hsa' ? '&pog_predom=YES' : '') + // limited to only planogram predom items
                           '&mfr_prod_code=' + mfr_prod_code +
                           '&mat_descr='     + mat_descr     +
                           '&category='      + category      +
                           '&promo='         + promo;

        axios.get(`/api/promoitem/search?${searchParams}`).then(response => {
            abcsetup.unblockUI();

            // First destroy any existing DataTable
            if ($.fn.DataTable.isDataTable('#results-table')) {
                $('#results-table').DataTable().destroy();
                $('#results-table').empty();
            }
            $('#item-modal').find('#results').empty();

            let html = ( abcsetup.item.type=='fsa_hsa' ?
                        '<div class="row m-0 px-3">'+
                            '<small class="text-muted alert alert-info col-12"><b>NOTE:</b> This promo type only allows for 4-foot Planogram Predominate Items. Non-POG Predominate items are excluded from the search results.</small>'+
                        '</div>' : '')+
                        '<div class="col-12">'+
                            '<table id="results-table" class="table table-striped table-sm table-bordered table-hover">'+
                                '<thead>'+
                                    '<tr>'+
                                        '<th></th>'+
                                        '<th></th>'+
                                        '<th>SAP #</th>'+
                                        '<th>UPC</th>'+
                                        '<th>AB 6-Digit Item #</th>'+
                                        '<th>Mfg. Part Number</th>'+
                                        '<th>Description</th>'+
                                        '<th>Category</th>'+
                                        '<th>Mat. Status</th>'+
                                        '<th>In Planogram</th>'+
                                        '<th>Predom. Planogram</th>'+
                                        '<th>Sales Dollars</th>'+
                                        '<th>Sales Units</th>'+
                                        '<th>Indep. Sales Dollars</th>'+
                                        '<th>Indep. Sales Units</th>'+
                                        '<th>TPR Sales Dollars</th>'+
                                        '<th>TPR Sales Units</th>'+
                                        '<th>#TPR Stores</th>'+
                                    '</tr>'+
                                '</thead>'+
                                '<tbody>';

            if (response.data && response.data.length > 0) {
                $(response.data).each(function() {
                    var row_class = '';
                    var button = '<button type="button" class="btn btn-primary btn-link btn-sm" data-id="' + this.id + '">Add</button>';
                    var promo_count = this.item_promo_count_next_year ? '<span class="promo_item_promos" data-item-id="'+this.id+'" title="Currently in ' + this.item_promo_count_next_year + ' promotions">'+this.item_promo_count_next_year+'</span>' : '';
                    abcsetup.promos.items.manage_items.items[this.id] = this;

                    if (this.mat_status == null || this.mat_status=="DM" || this.mat_status=="DB") {
                        button = '<button type="button" class="btn btn-primary btn-sm" disabled="disabled" title="Item Discontinued/Disabled">Add</button>';
                    }
                    html = html + '<tr class="' + row_class + '">\
                                        <td nowrap>' + button + '</td>\
                                        <td nowrap>' + promo_count + '</td>\
                                        <td>' + this.sap_num + '</td>\
                                        <td>' + ((this.upc11 != null) ? this.upc11 : '') + '</td>\
                                        <td>' + ((this.abc_6_digit != null) ? this.abc_6_digit : '') + '</td>\
                                        <td>' + ((this.mfr_prod_code != null) ? this.mfr_prod_code : '') + '</td>\
                                        <td>' + ((this.mat_descr != null) ? this.mat_descr : '') + '</td>\
                                        <td>' + ((this.a_b_c_fineline != null) ? this.a_b_c_fineline.category_name : '') + '</td>\
                                        <td>' + ((this.mat_status != null) ? this.mat_status : '') + '</td>\
                                        <td>' + ((this.planogram != null) ? this.planogram : '') + '</td>\
                                        <td>' + ((this.pog_predom != null) ? this.pog_predom : '') + '</td>\
                                        <td>' + ((this.annual_sales_dollars != null) ? this.annual_sales_dollars : '') + '</td>\
                                        <td>' + ((this.annual_sales_units != null) ? this.annual_sales_units : '') + '</td>\
                                        <td>' + ((this.independent_sales_dollars != null) ? this.independent_sales_dollars : '') + '</td>\
                                        <td>' + ((this.independent_sales_units != null) ? this.independent_sales_units : '') + '</td>\
                                        <td>' + ((this.tpr_sales_dollars != null) ? this.tpr_sales_dollars : '') + '</td>\
                                        <td>' + ((this.tpr_sales_units != null) ? this.tpr_sales_units : '') + '</td>\
                                        <td>' + ((this.num_tpr_stores_selling != null) ? this.num_tpr_stores_selling : '') + '</td>\
                                    </tr>';
                });
            } else {
                html = html + '<tr><td></td><td></td><td colspan="16" class="text-center">No data found</td></tr>';
            }

            html = html + '</tbody></table></div>';

            $('#item-modal').find('#results').html(html);

            // Initialize DataTable (only if we have rows and added small delay to ensure DOM is ready)
            setTimeout(() => {
                if (response.data && response.data.length > 0) {
                    abcsetup.datatables.client_side.init($('#results-table'), {
                        'dom': 'x',
                        'iDisplayLength': -1,
                        'order': [[2, 'asc']],
                        'responsive': false,
                        'destroy': true
                    });
                }

                // Apply the highlighting
                var body = $('#item-modal').find('#results tbody');
                body.unhighlight();

                category = category ? $('#item-modal').find('#category option:selected').text() : '';
                body.highlight([identifier, mfr_prod_code, mat_descr, category]);
            }, 0);
        });
    },
    showPromotions: function(id) {
        $('#item-promo-modal').modal('show');
        axios.get('/api/promoitem/search?action=get_promos&item='+id).then(response => {
            var html = '<div class="col-12">\
                            <table class="table table-striped table-sm table-bordered table-hover">\
                                <thead>\
                                    <tr>\
                                        <th>Promotion</th>\
                                        <th>Promotion Type</th>\
                                        <th>Start Run</th>\
                                        <th>End Run</th>\
                                        <th>Supplier Window Start</th>\
                                        <th>Supplier Window End</th>\
                                        <th>Item Status</th>\
                                        <th>Date Added</th>\
                                    </tr>\
                                </thead>';

            $(response.data).each(function() {
                html = html + '<tr >\
                                    <td>'+this.name+'</td>\
                                    <td>'+this.type_name+'</td>\
                                    <td>'+moment(this.start_run).format('MM/DD/Y')+'</td>\
                                    <td>'+moment(this.end_run).format('MM/DD/Y')+'</td>\
                                    <td>'+moment(this.start_vendor_submit).format('MM/DD/Y')+'</td>\
                                    <td>'+moment(this.end_vendor_submit).format('MM/DD/Y')+'</td>\
                                    <td>'+this.promo_items[0].promo_item_status.name+'</td>\
                                    <td>'+moment(this.promo_items[0].create_date).format('MM/DD/Y hh:mm A')+'</td>\
                                </tr>';
            });

            if (!response.data.length) {
                html = html + '<tr><td colspan="18" width="100%">No data found</td></tr>';
            }

            html = html + '</table></div>';
            $('#item-promo-modal').find('#results').html(html);

        });
    },
    /**
     * Add item
     */
    appendItem: function(id) {
        // Check if the item already exists in the promo
        if ($('input.item_id[value="' + abcsetup.promos.items.manage_items.items[id].id + '"]').length > 0) {
            abcsetup.alerts.show('Item already exists', 'This item is already part of this Event');
            return false;
        }

        // Check if the category has enough open slots for fsa_hsa
        if (abcsetup.item.type == 'fsa_hsa') {
            let vendor_in_process_items = 0;
            $('.category_id_'+abcsetup.promos.items.manage_items.items[id].a_b_c_fineline.category_id).each(function() {
                if ($(this).val() == 'vendor_in_process') {
                    vendor_in_process_items = vendor_in_process_items + 1;
                }
            });

            let open_slots = $('#open_slots_' + abcsetup.promos.items.manage_items.items[id].a_b_c_fineline.category_id + '').val() - vendor_in_process_items;
            if ((open_slots - 1) < 0) {
                abcsetup.alerts.show('No Open Item Slots', 'There are no more open item slots for this category: ' + abcsetup.promos.items.manage_items.items[id].a_b_c_fineline.category_name + '.');
                return false;
            }
        }

        // Add item to promo using ajax
        // Block the UI with a spinner
        abcsetup.blockUI(true);

        let promo_id = $('input[name="promo_id"]').val();

        axios.post('/api/promoitem/create?promo_id='+promo_id+'&item='+id)
            .then(response => {
                let data = response.data;

                if (response.data.error) {
                    abcsetup.unblockUI();
                    abcsetup.alerts.show('Could not add Item', response.data.error);
                    return false;
                }

                $('.no_items_message').remove();
                let checkbox = '';
                let btn_class = '';

                //The central banner ad and Consumer SearchBoost promo type does not require any item input from the supplier so we are setting them vendor_complete true
                //on item add. so they are not required to go in and save each item in order to submit
                if (abcsetup.item.type == 'gnp_central_banner_a' || abcsetup.item.type == 'cc' ) {
                    btn_class = 'btn-success';

                    checkbox =
                        `<div class="fancy-checks">
                            <div class="checkbox pt-2">
                                <label>
                                    <input type="checkbox" name="submitted_items[]" value="${id}" title="Click to select completed item for submission to Category Manager" class="form-check-input">
                                    <span class="cr" title="Click to select completed item for submission to Category Manager">
                                        <i class="cr-icon fa fa-check"></i>
                                    </span>
                                </label>
                            </div>
                        </div>`;
                }

                // Add a new item at the end of the promo item table
                let row = $("<tr class='vendor_in_process first'></tr>");

                if (abcsetup.item.type == 'hp') {
                    row.html(
                        `<td class='promoitem_select'>${checkbox}</td>
                            <td class='promoitem_options'>
                                <button type='button' class='btn btn-sm btn-danger tooltips btn-remove-item' title='Remove Item' data-item_id='_ID_'>
                                    <i class='fas fa-trash'></i>
                                </button>
                                <button type='button' class='btn btn-sm tooltips ${btn_class}' data-item_id='_ID_' title='Edit'></button>
                            </td>
                            <td class='promoitem_attachments'></td>
                            <td class='promoitem_sap_num'></td>
                            <td class='promoitem_upc11'></td>
                            <td class='promoitem_abc_6_digit'></td>
                            <td class='promoitem_mfg_part_num'></td>
                            <td class='promoitem_mat_descr' nowrap></td>
                            <td class='promoitem_cost' nowrap></td>
                            <td class='promoitem_discount_dollar' nowrap></td>
                            <td class='promoitem_status vendor_in_process' nowrap></td>
                            <td class='promoitem_date_added' nowrap></td>
                        `
                    );
                }
                else if (abcsetup.item.type == 'invoice_messaging') {
                    row.html(
                        `<td class='promoitem_select'>${checkbox}</td>
                            <td class='promoitem_options'>
                                <button type='button' class='btn btn-sm btn-danger tooltips btn-remove-item' title='Remove Item' data-item_id='_ID_'>
                                    <i class='fas fa-trash'></i>
                                </button>
                                <button type='button' class='btn btn-sm tooltips ${btn_class}' data-item_id='_ID_' title='Edit'></button>
                            </td>
                            <td class='promoitem_attachments'></td>
                            <td class='promoitem_sap_num'></td>
                            <td class='promoitem_upc11'></td>
                            <td class='promoitem_abc_6_digit'></td>
                            <td class='promoitem_mfg_part_num'></td>
                            <td class='promoitem_mat_descr' nowrap></td>
                            <td class='promoitem_status vendor_in_process' nowrap></td>
                            <td class='promoitem_date_added' nowrap></td>
                        `
                    );
                }
                else if (abcsetup.item.type == 'cc' || abcsetup.item.type == 'hhc') {
                    row.html(
                        `<td class='promoitem_select'>${checkbox}</td>
                            <td class='promoitem_options'>
                                <button type='button' class='btn btn-sm btn-danger tooltips btn-remove-item' title='Remove Item' data-item_id='_ID_'>
                                    <i class='fas fa-trash'></i>
                                </button>
                                <button type='button' class='btn btn-sm tooltips ${btn_class}' data-item_id='_ID_' title='Edit'></button>
                            </td>
                            <td class='promoitem_attachments'></td>
                            <td class='promoitem_sap_num'></td>
                            <td class='promoitem_upc11'></td>
                            <td class='promoitem_abc_6_digit'></td>
                            <td class='promoitem_mfg_part_num'></td>
                            <td class='promoitem_mat_descr' nowrap></td>
                            <td class='promoitem_cost' nowrap></td>
                            <td class='promoitem_status vendor_in_process' nowrap></td>
                            <td class='promoitem_date_added' nowrap></td>
                        `
                    );
                }
                else if (abcsetup.item.type == 'ecomm_sol') {
                    row.html(
                        `<td class='promoitem_select'>${checkbox}</td>
                            <td class='promoitem_options'>
                                <button type='button' class='btn btn-sm btn-danger tooltips btn-remove-item' title='Remove Item' data-item_id='_ID_'>
                                    <i class='fas fa-trash'></i>
                                </button>
                                <button type='button' class='btn btn-sm tooltips ${btn_class}' data-item_id='_ID_' title='Edit'></button>
                            </td>
                            <td class='promoitem_attachments'></td>
                            <td class='promoitem_sap_num'></td>
                            <td class='promoitem_upc11'></td>
                            <td class='promoitem_abc_6_digit'></td>
                            <td class='promoitem_mfg_part_num'></td>
                            <td class='promoitem_mat_descr' nowrap></td>
                            <td class='promoitem_temp_range' nowrap></td>
                            <td class='promoitem_cost' nowrap></td>
                            <td class='promoitem_billback_perc' nowrap></td>
                            <td class='promoitem_status vendor_in_process' nowrap></td>
                            <td class='promoitem_date_added' nowrap></td>
                        `
                    );
                }
                else if (abcsetup.item.type == 'bgp') {
                    checkbox = ``; // no checkbox for bgp promotions
                    row.html(
                        `<td class='promoitem_select'>${checkbox}</td>
                             <td class='promoitem_options'>
                                <button type='button' class='btn btn-sm btn-danger tooltips btn-remove-item' title='Remove Item' data-item_id='_ID_'>
                                    <i class='fas fa-trash'></i>
                                </button>
                                <button type='button' class='btn btn-sm tooltips ${btn_class}' data-item_id='_ID_' title='Edit'></button>
                            </td>
                            <td class='promoitem_attachments'></td>
                            <td class='promoitem_sap_num'></td>
                            <td class='promoitem_upc11'></td>
                            <td class='promoitem_abc_6_digit'></td>
                            <td class='promoitem_mfg_part_num'></td>
                            <td class='promoitem_mat_descr' nowrap></td>
                            <td class='promoitem_billback_perc' nowrap></td>
                            <td class='promoitem_status vendor_in_process' nowrap></td>
                            <td class='promoitem_date_added' nowrap></td>
                        `
                    );
                }
                else if (abcsetup.item.type == 'ddp') {
                    checkbox = ``; // no checkbox for bgp promotions
                    row.html(
                        `<td class='promoitem_select'>${checkbox}</td>
                             <td class='promoitem_options'>
                                <button type='button' class='btn btn-sm btn-danger tooltips btn-remove-item' title='Remove Item' data-item_id='_ID_'>
                                    <i class='fas fa-trash'></i>
                                </button>
                                <button type='button' class='btn btn-sm tooltips ${btn_class}' data-item_id='_ID_' title='Edit'></button>
                            </td>
                            <td class='promoitem_attachments'></td>
                            <td class='promoitem_sap_num'></td>
                            <td class='promoitem_upc11'></td>
                            <td class='promoitem_abc_6_digit'></td>
                            <td class='promoitem_mfg_part_num'></td>
                            <td class='promoitem_mat_descr' nowrap></td>
                            <td class='promoitem_cost' nowrap></td>
                            <td class='promoitem_status vendor_in_process' nowrap></td>
                            <td class='promoitem_date_added' nowrap></td>
                        `
                    );
                }
                else if (abcsetup.item.type == 'ccp') {
                    row.html(
                        `<td class='promoitem_options'>
                                <button type='button' class='btn btn-sm btn-danger tooltips btn-remove-item' title='Remove Item' data-item_id='_ID_'>
                                    <i class='fas fa-trash'></i>
                                </button>
                            </td>
                            <td class='promoitem_sap_num'></td>
                            <td class='promoitem_upc11'></td>
                            <td class='promoitem_abc_6_digit'></td>
                            <td class='promoitem_mfg_part_num'></td>
                            <td class='promoitem_mat_descr' nowrap></td>
                            <td class="promoitem_smarttip_message" nowrap></td>
                            <td class="promoitem_inv_message"></td>
                            <td class='promoitem_status vendor_in_process' nowrap></td>
                            <td class='promoitem_date_added' nowrap></td>
                        `
                    );
                }
                else {
                    row.html(
                        `<td class='promoitem_select'>${checkbox}</td>
                            <td class='promoitem_options'>
                                <button type='button' class='btn btn-sm btn-danger tooltips btn-remove-item' title='Remove Item' data-item_id='_ID_'>
                                    <i class='fas fa-trash'></i>
                                </button>
                                <button type='button' class='btn btn-sm tooltips ${btn_class}' data-item_id='_ID_' title='Edit'></button>
                            </td>
                            <td class='promoitem_attachments'></td>
                            <td class='promoitem_sap_num'></td>
                            <td class='promoitem_upc11'></td>
                            <td class='promoitem_abc_6_digit'></td>
                            <td class='promoitem_mfg_part_num'></td>
                            <td class='promoitem_mat_descr' nowrap></td>
                            <td class='promoitem_cost' nowrap></td>
                            <td class='promoitem_billback_perc' nowrap></td>
                            <td class='promoitem_status vendor_in_process' nowrap></td>
                            <td class='promoitem_date_added' nowrap></td>
                        `
                    );
                }

                if (data.attachments != null && data.attachments != undefined) {

                    let attachment_html = `<ul>`;
                    let promo_attachment_html = '';

                    for (let i in data.attachments) {
                        let attachment = data.attachments[i];
                        let deleteIconHtml =
                             `<i class="far fa-trash-alt text-danger delete-attachment-autoappend" title="Delete Attachment" data-type="${attachment.type_id}__promo${promo_id}__" data-id="${attachment.id}"></i>`
                            ;

                        attachment_html += `
                            <li>
                                <a
                                    href="/attachments/preview/${attachment.upload_uuid}"
                                    class="text-center ${attachment.type_id} uuid-${attachment.upload_uuid}"
                                    data-type="${attachment.type_id}"
                                    target="_blank"
                                >
                                    <img src="/attachments/thumb/${attachment.upload_uuid}">
                                </a>
                            </li>
                        `;

                        promo_attachment_html += `
                            <div class="attachment-item">
                                <a href="/attachments/download/${attachment.upload_uuid}" class="col-12 col-md-3 text-center attachment-link-thumb ${attachment.type_id} uuid-${attachment.upload_uuid}" data-type="${attachment.type_id}__promo${promo_id}__" target="_blank">
                                    <img src="/attachments/thumb/${attachment.upload_uuid}" alt="Attachment Thumbnail">
                                    <span class="hide value">${attachment.id}</span>
                                    <br>
                                    ${attachment.type_name}
                                    <br>
                                    <small>${attachment.filename}</small>
                                    ${deleteIconHtml}
                                </a>
                                <input type="hidden" class="attachment_file" value="${attachment.id}">
                            </div>
                        `;
                    }

                    row.find('.promoitem_attachments').append(attachment_html + `</ul>`);
                    $('#attachments .existing .row').append(promo_attachment_html);

                    let buttonSelector = `button[data-entity_id="${promo_id}"][id^="product_image__promo"]`;
                    $(buttonSelector).removeClass('required btn-danger').hide().attr('data-required', 'true');
                }

                if (abcsetup.item.type != 'ccp') {
                    row.find('.promoitem_options').html('<button type="button" class="btn btn-sm btn-danger tooltips btn-remove-item" data-item_id="'+id+'" title="Remove Item"><i class="fas fa-trash"></i></button>&nbsp;<a class="btn btn-sm btn-warning tooltips" data-item_id="'+id+'" title="Edit" href="'+response.data.edit_url+'"><i class="fas fa-pen"></i></a>');
                }
                else {
                    row.find('.promoitem_options').html('<button type="button" class="btn btn-sm btn-danger tooltips btn-remove-item" data-item_id="'+id+'" title="Remove Item"><i class="fas fa-trash"></i></button>');
                }

                row.find('.promoitem_sap_num').html(abcsetup.promos.items.manage_items.items[id].sap_num);
                row.find('.promoitem_upc11').html(abcsetup.promos.items.manage_items.items[id].upc11);
                row.find('.promoitem_abc_6_digit').html(abcsetup.promos.items.manage_items.items[id].abc_6_digit);
                row.find('.promoitem_mfg_part_num').html(abcsetup.promos.items.manage_items.items[id].mfr_prod_code);
                row.find('.promoitem_mat_descr').html('<b>'+abcsetup.promos.items.manage_items.items[id].mat_descr+'</b><br>'+abcsetup.promos.items.manage_items.items[id].a_b_c_fineline.category_name);
                row.find('.promoitem_temp_range').html(abcsetup.promos.items.manage_items.items[id].temp_conditions_display_name);
                row.find('.promoitem_cost').html(typeof data.promo_item != 'undefined' ? data.promo_item.cost : '');

                if (abcsetup.item.type == 'hp') {
                    row.find('.promoitem_discount_dollar').html("<input class=\"discount_dollar_field\" type=\"number\" name=\"discount_"+id+"\" min=\"0.00\" max=\"9999\" step=\"0.01\"/><a href=\"#\" class=\"copy-to-all-dollar\">Copy to all</a></td>");
                }
                else if (abcsetup.item.type != 'invoice_messaging' && abcsetup.item.type != 'cc' && abcsetup.item.type != 'hhc' && abcsetup.item.type != 'ccp' && abcsetup.item.type != 'ddp') {
                    row.find('.promoitem_billback_perc').html("<input type=\"number\" class=\"billback_field\" name=\"billback_"+id+"\" min=\"0.00\" max=\"99\" step=\"0.01\"><a href=\"#\" class=\"copy-to-all-billback\">Copy to all</a></td>");
                }

                row.find('.promoitem_status').removeClass().addClass('promoitem_status').addClass('vendor_in_process').html('Supplier: In Process');
                row.find('.promoitem_date_added').html(moment(data.promo_item.create_date).format('MM/DD/Y hh:mm A'));

                // Update second row values
                var html = '<tr class="first new_item">' + row.html() + '</tr>';
                $('table.promo_items > tbody > tr.header:first').show();
                $('table.promo_items > tbody > tr.header:first').after(html).show();
                $('table.promo_items > tbody').show();

                $(".btn-link[data-id="+id+"]").closest("tr").remove();

                abcsetup.unblockUI();
            })
            .catch(error => {
                console.error(error.response.data.message);
                abcsetup.unblockUI();
                abcsetup.alerts.show('Could not add Item', 'An error occurred while adding the item. ' + error.response.data.message);
            });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the callback
     */
    fieldsInit: function() {
        // Note: all promo item form related JS is handled in the global /forms/_promo_item.js form namespace
        abcsetup.promos.items.form.init(true);
    },

    // Just the Promo Level attachments need to be 'AutoSaved'
    // PromoItem and PageBLocks have a Save button
    uploadDone: function() {
        // Save the Attachment to the Promotion
        var attachments_form = $('<form class="attachments"></form>');
        attachments_form.append('<input type="hidden" class="tmp-action" name="form_action" value="save_attachments">');
        attachments_form.append($('input[name="promo_attachments[]"]').clone());

        axios.post('/promo/' + abcsetup.item.id + '/update_items', attachments_form.serialize()).then(response => {
            console.log("Promo Attachments Updated");
        });
    },
    uploadDoneAfterAutoAppend: function() {
        abcsetup.promos.items.manage_items.uploadDone();
    },
    attachmentRemoved: function () {
        abcsetup.promos.items.manage_items.uploadDone();
    },
    /**
     * fieldError callback from _jquery.fieldValidate
     */
    fieldError: function() {
        var errorField = $('form.manage-items').find('.invalid').first();
        if (errorField.hasClass('attachment_file') || errorField.attr('name').includes('attachment')) {
            $('#attachments-tab').tab('show');
        }

        errorField.trigger('click').trigger('focus');
        errorField[0].scrollIntoView({
            behavior: "smooth", // or "auto" or "instant"
            block: "start" // or "end"
        });
    },
}
